import React, { createContext, useContext } from 'react';

/**
 * SSR Data Context
 * 
 * During SSR, server.js fetches data from Supabase and passes it through
 * this context so React components can render with real data instead of
 * showing "Loading..." states.
 * 
 * During client hydration, the data is read from window.__SSR_DATA__
 * (injected by server.js into the HTML) and provided through the same context.
 */

interface SSRContextData {
  vehicle?: any;
  vehicleImages?: any[];
  inventory?: any[];
  faqs?: any[];
}

const SSRDataContext = createContext<SSRContextData>({});

export function SSRDataProvider({ 
  data, 
  children 
}: { 
  data?: SSRContextData; 
  children: React.ReactNode 
}) {
  // In browser, merge with window.__SSR_DATA__ if server data is not passed
  const contextData = data || 
    (typeof window !== 'undefined' ? window.__SSR_DATA__ || {} : {});
  
  return (
    <SSRDataContext.Provider value={contextData}>
      {children}
    </SSRDataContext.Provider>
  );
}

export function useSSRData(): SSRContextData {
  return useContext(SSRDataContext);
}
